<template>
  <div class="modal fade" id="ExportServiceBundle" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-10 my-auto">
            <h5 class="modal-title" id="EndBankAccountLabel">Export Service Bundle</h5>
          </div>
          <div class="col-2 my-auto">
            <span>
              <a @click="clearFields" class="close">
                <i
                  class="far fa-times-circle fa-2x"
                  data-dismiss="modal"
                  id="closeExportServiceBundle"
                  aria-label="Close"
                ></i>
              </a>
            </span>
          </div>
        </div>
        <div class="container-fluid">
          <form @submit.prevent="submit">
            <div class="modal-body">
              <!-- <b-form-select v-model="serviceBundle" class="form-control" name="selection" required>
                    <option v-for="(bundle, index) in serviceBundleList" :key="index" :value="bundle">{{bundle.ServiceBundleName}}</option>
              </b-form-select>-->
              <div class="col-12">
                <div class="input-group" v-if="!serviceBundle">
                  <input
                    v-model="serviceBundleSearch"
                    @keyup="search()"
                    type="text"
                    class="form-control underline"
                    name="Search for a bundle"
                    placeholder="Please start typing....."
                    pattern="^[A-Za-z -]+$"
                  />
                </div>
                <!-- This button only appears when a bundle has been selected -->
                <div class="d-flex align-items-end flex-column h-100" v-if="serviceBundle">
                  <template>
                    <b-table
                      responsive
                      outlined
                      striped
                      :items="[serviceBundle]"
                      :fields="searchResultFields"
                    >
                      <template slot="name" slot-scope="data">{{data.item.name}}</template>
                      <template slot="description" slot-scope="data">{{data.item.description}}</template>
                      <template slot="action">
                        <a href="#" onclick="return false;" @click="clearSelection">
                          <img src="@/assets/img/remove_icon.png" />
                        </a>
                      </template>
                    </b-table>
                  </template>
                </div>
                <!-- This is where the search results start -->
                <div class="col no-pad bg-white sfab-search-results">
                  <div
                    class="row"
                    v-if="(results && (results == 0 || !results)) && serviceBundleSearch.length > 0"
                  >
                    <div class="col-12">
                      <div class="mx-auto p-3">
                        <h5>Search Results:</h5>
                        <p class="d-inline">Sorry, no results found. Please try again.</p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-else-if="results && results.length >= 1 && serviceBundleSearch.length > 2"
                  >
                    <div class="col-sm">
                      <div class="mx-auto p-3">
                        <template>
                          <b-list-group>
                            <b-list-group-item
                              href="#"
                              @click="selectServiceBundle(result.Document)"
                              v-for="(result, rIndex) in results"
                              :key="rIndex"
                            >{{result.Document.ServiceBundleName}}</b-list-group-item>
                          </b-list-group>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- This is where the search results end -->
              </div>
              <div class="container-fluid">
                <div class="row text-center mt-3">
                  <!-- <div class="error" v-if="!$v.serviceBundle.required"></div> -->
                  <div v-if="serviceBundle" class="col-sm-12 no-pad">
                    <b-button
                      @click="download"
                      class="btn btn-hc w-40 mr-2 mb-3"
                      :disabled="submitStatus === 'PENDING'"
                    >Download</b-button>
                    <button
                      @click="clearFields"
                      type="submit"
                      class="btn btn-hc w-40 ml-2 mb-3"
                      data-dismiss="modal"
                      aria-label="Close"
                    >Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';

export default {
	data() {
		return {
			submitStatus: null,
			searchResultFields: {
				name: {
					key: 'ServiceBundleName',
					label: 'Service Bundle',
					class: 'text-center',
				},
				description: {
					key: 'ServiceBundleDescription',
					label: 'Description',
					class: 'text-center',
				},
				action: {
					label: '',
					class: 'text-center',
				},
			},
		};
	},
	validations() {
		return {
			serviceBundle: {
				required,
			},
		};
	},
	computed: {
		accessToken() {
			return this.$auth.accessToken;
		},
		xsrfToken() {
			return this.$auth.xsrfToken;
		},
		contractbot() {
			return this.$config.honeycomb.contractbot.domain;
		},
		serviceBundleSearch: {
			get() {
				return this.$store.state.contracts.serviceBundleExportSearch;
			},
			set(search) {
				this.$store.commit('updateServiceBundleExportSearch', search);
			},
		},
		results: {
			get() {
				return this.$store.state.serviceBundleResults;
			},
			set(results) {
				this.$store.commit('updateServiceBundleResults', {
					Results: results,
					Index: 'Export',
				});
			},
		},
		serviceBundle: {
			get() {
				return this.$store.state.contracts.serviceBundleExport;
			},
			set(serviceBundle) {
				this.$store.commit('updateServiceBundleExport', serviceBundle);
			},
		},
	},
	methods: {
		download() {
			this.$store
				.dispatch('getBundleByReference', this.serviceBundle.ServiceBundleId)
				.then((bundle) => {
					const data = JSON.stringify(bundle.data, null, 1);
					const blob = new Blob([data], { type: 'text/plain' });
					const e = document.createEvent('MouseEvents'),
						a = document.createElement('a');
					a.download = this.serviceBundle.ServiceBundleName + '.json';
					a.href = window.URL.createObjectURL(blob);
					a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
					e.initEvent(
						'click',
						true,
						false,
						window,
						0,
						0,
						0,
						0,
						0,
						false,
						false,
						false,
						false,
						0,
						null
					);
					a.dispatchEvent(e);
				});
		},
		search() {
			this.$store.dispatch('serviceBundleSearch', {
				Criteria: this.serviceBundleSearch,
				Index: 'Export',
			});
		},
		selectServiceBundle(serviceBundle) {
			this.$store.commit('resetServiceBundleResults');
			this.serviceBundleSearch = null;
			this.serviceBundle = serviceBundle;
		},
		clearSelection() {
			this.serviceBundle = null;
		},
		clearFields() {
			this.$store.commit('resetServiceBundleResults');
			this.serviceBundleSearch = null;
			this.serviceBundle = null;
			document.getElementById('closeExportServiceBundle').click();
		},
	},
};
</script>
